export const customMessages = {
  'idProduto': {
    'string.base': '(Produto) deve ser preenchido.',
    'string.empty': '(Produto) deve ser preenchido.',
    'string.guid': '(Produto) deve ser preenchido.',
    'any.required': '(Produto) deve ser preenchido.',
  },
  'idCompra': {
    'string.base': '(Compra) deve estar salva',
    'string.empty': '(Compra) deve estar salva',
    'string.guid': '(Compra) deve estar salva',
    'any.required': '(Compra) deve estar salva'
  },
  'quantidade': {
    'number.base': '(Quantidade) deve ser preenchido.',
    'number.empty': '(Quantidade) deve ser preenchido.',
    'number.integer': '(Quantidade) deve ser preenchido.',
    'any.required': '(Quantidade) deve ser preenchido.'
  },
  'valorUnitario': {
    'number.base': '(Valor) deve ser preenchido.',
    'number.empty': '(Valor) deve ser preenchido.',
    'number.integer': '(Valor) deve ser preenchido.',
    'any.required': '(Valor) deve ser preenchido.'
  },
  'tipoProduto': {
    "any.only": "(Tipo Produto) incorreto, valores corretos são ('normal', 'agrotoxico')"
  },
  'idAgrotoxico': {
    'number.base': '(Agrotóxico) deve ser preenchido.',
    'number.empty': '(Agrotóxico) deve ser preenchido.',
    'number.integer': '(Agrotóxico) deve ser preenchido.',
    'any.required': '(Agrotóxico) deve ser preenchido.',
  },
  'agrotoxico': {
    'string.base': '(Nome do agrotóxico) deve ser preenchido.',
    'string.empty': '(Nome do agrotóxico) deve ser preenchido.',
    'string.guid': '(Nome do agrotóxico) deve ser preenchido.',
    'any.required': '(Nome do agrotóxico) deve ser preenchido.',
  },
  'idEmbalagem': {
    'number.base': '(Embalagem) deve ser preenchida.',
    'number.empty': '(Embalagem) deve ser preenchida.',
    'number.integer': '(Embalagem) deve ser preenchida.',
    'any.required': '(Embalagem) deve ser preenchida.',
  },
  'embalagem': {
    'string.base': '(Nome da embalagem) deve ser preenchida.',
    'string.empty': '(Nome da embalagem) deve ser preenchida.',
    'string.guid': '(Nome da embalagem) deve ser preenchida.',
    'any.required': '(Nome da embalagem) deve ser preenchida.',
  },
  'registroAgrotox': {
    'string.base': '(Registro do agrotóxico) deve ser preenchido.',
    'string.empty': '(Registro do agrotóxico) deve ser preenchido.',
    'string.guid': '(Registro do agrotóxico) deve ser preenchido.',
    'any.required': '(Registro do agrotóxico) deve ser preenchido.',
  },
};